import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../pages/auth/login";
import { Validate } from "../pages/auth/validate";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/validate" element={<Validate />} />
        <Route path="*" element={<Navigate to="/login" />} />
       
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
